import NewsSummaryPage from "@components/news-summary-page";
import * as Sentry from "@sentry/browser";
import { PageNewsComp, ssrAllNews, ssrNews } from "@graphql/generated/page";
import {
  useNewsPageLazyQuery,
  useNewsPageQuery,
} from "@graphql/generated/graphql";
import { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";
import { loadTranslation } from "@lib/utils";
import Layout from "@components/layout/layout";
import { useEffect, useState } from "react";
import { Trans, t } from "@lingui/macro";
import { ta } from "date-fns/locale";
import { FaTags } from "react-icons/fa";
import LumiNewsArticleJsonLd from "@components/seo/lumi-news-article-json-ld";

// export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
// const translation = await loadTranslation(
//   locale,
//   process.env.NODE_ENV == "production"
// );

// const {
//   props: { data },
// } = await ssrNews.getServerPage(
//   {
//     variables: {
//       id: params?.id?.toString() || "",
//       languageCode: locale,
//     },
//   },
//   null
// );

// if (!data.news) {
//   const errorMessage = `Error from data news ${params?.id?.toString()}`;
//   const errorDetails = {
//     data: data, errorMessage
//   };
//   // Sentry.captureException(new Error(errorMessage), {
//   //   extra: errorDetails,
//   // });
//   return {
//     notFound: true,
//   };
// }

// return { props: { data, translation } };
// };

// export const getStaticPaths: GetStaticPaths = async () => {
// const {
//   props: { data },
// } = await ssrAllNews.getServerPage({}, null);

// const paths = data.allNews?.map(({ id }) => ({ params: { id } })) || [];

// return {
//   paths,
//   fallback: "blocking",
// };
// };

const News: PageNewsComp = () => {
  const router = useRouter();
  const { locale } = router;

  const [getNews, { data, error, loading, fetchMore }] = useNewsPageLazyQuery();
  const commentsLimit = 3;
  const publisherNewsLimit = 5;

  useEffect(() => {
    getNews({
      variables: {
        id: router.query.id as string,
        commentsLimit: commentsLimit,
        publisherNewsLimit: publisherNewsLimit,
        languageCode: locale,
      },
    });
  }, [getNews, locale, router.query]);

  return (
    <>
      <LumiNewsArticleJsonLd data={data} />
      <NewsSummaryPage
        data={data}
        loading={loading}
        fetchMore={fetchMore}
        limit={commentsLimit}
      />
    </>
  );
};

export default News;
